// Staff admin for the Broker Commission Modeler's four program numbers. Gated
// Partners.ManageBrands (reused deliberately — see CommissionModelerTermsController;
// it already carries the broker-tooling audience C0/C1/C5 + ADMIN).
//
// 🔴 Both rates are FRACTIONS on the wire (0.10 = 10%). The page edits them as
// PERCENTS and converts on save/display; nothing else may. Hooks in
// @/hooks/portfolioAdmin/useCommissionModelerTerms wrap these with TanStack Query.

import { api } from "@/api/client";

export interface CommissionModelerTermsConfigDto {
  /** The buyer's contract rate as a FRACTION (0.10 = 10%). */
  interestRate: number;
  /** The seller's rate as a FRACTION. Phoenix's spread is the difference. */
  sellerInterestRate: number;
  amortizationMonths: number;
  liquidityEventMonth: number;
  /** False when no override is saved and these are the code defaults. */
  isOverridden: boolean;
  /** When the override was last saved; null when there is none. */
  updatedAt: string | null;
}

export interface UpdateCommissionModelerTermsRequest {
  /** FRACTION; the server rejects < 0 or >= 1. */
  interestRate: number;
  /** FRACTION; the server also rejects a value above interestRate. */
  sellerInterestRate: number;
  amortizationMonths: number;
  /** Must be > 0 and <= amortizationMonths. */
  liquidityEventMonth: number;
}

export const commissionModelerTermsApi = {
  get: () =>
    api.get<CommissionModelerTermsConfigDto>(
      `/portfolio-admin/commission-modeler-terms`,
    ),
  update: (body: UpdateCommissionModelerTermsRequest) =>
    api.put<CommissionModelerTermsConfigDto>(
      `/portfolio-admin/commission-modeler-terms`,
      body,
    ),
};
